export interface Volume {
  number: string;
  title: string;
  description: string;
  cover: string;
}

export const volumes: Volume[] = [
  {
    number: '01',
    title: 'Budowa atomu i układ okresowy',
    description:
      'Atom, pierwiastki, cząstki subatomowe, konfiguracje i układ okresowy przedstawione krok po kroku.',
    cover:
      'https://cdn.magicpatterns.com/uploads/6KMvRMQ4a42DYjjhMQtgwt/chemia-wizualna-tom-01-budowa-atomu-i-uklad-okresowy.webp',
  },
  {
    number: '02',
    title: 'Wiązania chemiczne i hybrydyzacja',
    description:
      'Wiązania, struktury i modele pomagające uczniom zrozumieć, jak i dlaczego atomy łączą się ze sobą.',
    cover:
      'https://cdn.magicpatterns.com/uploads/5rkYouGzH2rtZZkKe4tXYg/chemia-wizualna-tom-02-wiazania-chemiczne-i-hybrydyzacja.webp',
  },
  {
    number: '03',
    title: 'Reakcje chemiczne',
    description:
      'Rozpoznawanie, zapisywanie i analizowanie reakcji chemicznych w jasnej, uporządkowanej formie.',
    cover:
      'https://cdn.magicpatterns.com/uploads/7eyMw8uYfcELXwe3AdUHUS/chemia-wizualna-tom-03-reakcje-chemiczne.webp',
  },
  {
    number: '04',
    title: 'Roztwory i stężenia',
    description:
      'Roztwory, obliczenia i stężenia przedstawione w sposób wizualny, praktyczny i możliwy do przećwiczenia.',
    cover:
      'https://cdn.magicpatterns.com/uploads/vmAwgfahhtXKP99wjWizHp/chemia-wizualna-tom-04-roztwory-i-stezenia.webp',
  },
  {
    number: '05',
    title: 'Kwasy, zasady i pH',
    description: 'pH, pOH, wskaźniki, bufory i miareczkowanie z przykładami, obliczeniami i zadaniami.',
    cover:
      'https://cdn.magicpatterns.com/uploads/7EKDB7icQteSr8USpXd36b/chemia-wizualna-tom-05-kwasy-zasady-i-ph.webp',
  },
  {
    number: '06',
    title: 'Chemia organiczna',
    description:
      'Podstawy chemii organicznej uporządkowane tak, aby uczniowie mogli zobaczyć związki, zależności i zastosowania.',
    cover:
      'https://cdn.magicpatterns.com/uploads/8L5Hv2wT4sdjVP5kXzWE1y/chemia-wizualna-tom-06-chemia-organiczna.webp',
  },
  {
    number: '07',
    title: 'Doświadczenia laboratoryjne i projekty',
    description:
      'Gotowe inspiracje do doświadczeń, pracy praktycznej i projektów, które ożywiają lekcje chemii.',
    cover:
      'https://cdn.magicpatterns.com/uploads/2vN6nvLeUHB9jErPCP2X8A/chemia-wizualna-tom-07-doswiadczenia-i-projekty-laboratoryjne.webp',
  },
];

export interface Bonus {
  badge: string;
  title: string;
  description: string;
}

export const bonuses: Bonus[] = [
  {
    badge: 'BONUS 1',
    title: '30 tygodni planów lekcji',
    description:
      'Pomaga uporządkować pracę w ciągu roku i szybciej przygotować kolejne zajęcia.',
  },
  {
    badge: 'BONUS 2',
    title: 'Bank ewaluacji i sprawdzianów',
    description:
      'Gotowe narzędzia do sprawdzania postępów uczniów bez tworzenia każdej oceny od zera.',
  },
  {
    badge: 'BONUS 3',
    title: 'Klucz odpowiedzi i przewodnik metodyczny',
    description:
      'Ułatwia sprawdzanie prac oraz prowadzenie lekcji z większą pewnością i spójnością.',
  },
];

/**
 * Wyłącznie zweryfikowane, autoryzowane opinie.
 * Dopóki tablica jest pusta, sekcja pokazuje zastosowania materiałów — bez fikcyjnych cytatów i ocen.
 */
export interface Testimonial {
  verified: boolean;
  quote: string;
  name: string;
  city: string;
  role: string;
  rating?: number;
}

export const testimonials: Testimonial[] = [];

export interface UsageCard {
  title: string;
  description: string;
}

export const usageCards: UsageCard[] = [
  {
    title: 'Wyjaśniaj',
    description: 'Wizualne strony pomagają wprowadzać trudne pojęcia krok po kroku.',
  },
  {
    title: 'Ćwicz',
    description: 'Gotowe zadania pozwalają uczniom pracować samodzielnie, w parach lub grupach.',
  },
  {
    title: 'Sprawdzaj',
    description: 'Sprawdziany, klucze i materiały wspierają powtórkę oraz ocenę postępów.',
  },
];

export interface Faq {
  question: string;
  answer: string;
}

export const faqs: Faq[] = [
  {
    question: 'Co dokładnie otrzymam?',
    answer:
      'Otrzymasz dostęp cyfrowy do 7 tomów Wizualnej Chemii™ oraz 3 bonusów dla nauczyciela.',
  },
  {
    question: 'Czy to produkt fizyczny?',
    answer: 'Nie. To zestaw materiałów cyfrowych, które możesz pobrać i wydrukować.',
  },
  {
    question: 'Kiedy otrzymam materiały?',
    answer: 'Dostęp cyfrowy otrzymasz zaraz po zakończeniu zakupu.',
  },
  {
    question: 'Czy to abonament?',
    answer: 'Nie. Płacisz jednorazowo 17 USD. Nie ma miesięcznej subskrypcji.',
  },
  {
    question: 'Dla jakich klas przeznaczone są materiały?',
    answer:
      'Materiały zostały przygotowane z myślą o nauczycielach chemii klas 7–8, liceum i technikum.',
  },
  {
    question: 'Czy klucze odpowiedzi są w zestawie?',
    answer: 'Tak. Klucz odpowiedzi i przewodnik metodyczny są zawarte w Bonusie 3.',
  },
  {
    question: 'Czy mogę używać materiałów z własnymi uczniami?',
    answer:
      'Tak. Materiały są przeznaczone do pracy nauczyciela z własnymi uczniami. Nie wolno ich odsprzedawać ani udostępniać jako własnych materiałów.',
  },
];

export interface SamplePage {
  src: string;
  alt: string;
  caption: string;
}

export const samplePages: SamplePage[] = [
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/3306744d-7f58-4b4f-b87c-265515ea1d5b.jpg',
    alt: 'Strona teorii z modelem atomu i diagramem orbitali',
    caption: 'Strony teorii',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/45665431-93b4-451c-9b70-3708c9888ea5.jpg',
    alt: 'Karta ćwiczeń z miejscem na obliczenia i zapis równań',
    caption: 'Ćwiczenia dla uczniów',
  },
  {
    src: 'https://cdn.magicpatterns.com/patterns/generated-images/32fe7e5e-2db6-40dd-be71-3f03fa796e1d.jpg',
    alt: 'Karty laboratoryjne z instrukcją doświadczenia i tabelą pomiarów',
    caption: 'Materiały laboratoryjne',
  },
];
